export default "__VITE_PUBLIC_ASSET__6ff8961d__"